import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#060b18] border-t border-slate-800/80 text-slate-400 py-6 px-4 sm:px-6 lg:px-8 mt-auto">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-xs">
        
        {/* Left: Copyright */}
        <div className="flex items-center gap-2">
          <span>&copy; {currentYear} Logan Executive Transport. All rights reserved.</span>
        </div>

        {/* Right: Designed and Developed by The Vivid Digital */}
        <div className="flex items-center gap-1.5 text-slate-400">
          <span>Designed & Developed by</span>
          <a
            href="https://thevividdigital.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 font-bold transition-colors underline-offset-2 hover:underline inline-flex items-center gap-1"
          >
            The Vivid Digital
            <span className="material-symbols-outlined !text-[13px]">open_in_new</span>
          </a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
